/** Как растягивается подложка под спиннер и где он центрируется. */
export enum AppLoadSpinnerCenteredPosition {
  /** Обычный блок в потоке; при `centered` центрирование через `LoaderSpinner`. */
  none = 'none',
  /** Оверлей на весь вьюпорт */
  screen = 'screen',
  /** Оверлей на позиционированного родителя */
  container = 'container'
}
